import React from "react";
import { GraduationCap, Globe2, MonitorSmartphone, Award } from "lucide-react";

const CARDS = [
  {
    icon: <GraduationCap className="h-5 w-5" strokeWidth={1.6} />,
    title: "50+ years of distance learning",
    body: "Founded in 1974, AIOU is Pakistan's first and the world's 4th-largest open university.",
  },
  {
    icon: <Globe2 className="h-5 w-5" strokeWidth={1.6} />,
    title: "Students in 35+ countries",
    body: "Active overseas students across the GCC, UK, Europe, North America, Australia and Africa.",
  },
  {
    icon: <MonitorSmartphone className="h-5 w-5" strokeWidth={1.6} />,
    title: "Fully online study",
    body: "Lectures on the Aaghi LMS, assignments submitted online, and most exams conducted online with remote proctoring.",
  },
  {
    icon: <Award className="h-5 w-5" strokeWidth={1.6} />,
    title: "HEC-recognised globally",
    body: "Degrees accepted by overseas universities and employers after the standard HEC attestation chain.",
  },
];

export const WhyAIOU = () => {
  return (
    <section
      id="why"
      data-testid="why-aiou"
      className="py-20 md:py-24 border-y border-aiou-sand/70 bg-white/50"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.2em] text-aiou-gold font-semibold">
            Why choose AIOU
          </span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-aiou-ink leading-[1.1] tracking-tight">
            Pakistan's most trusted open university — built for students
            studying from abroad.
          </h2>
          <p className="mt-5 text-aiou-slate text-base sm:text-lg leading-relaxed">
            AIOU has spent five decades perfecting open and distance learning.
            For international students, that means flexible programs, online
            exams, and a degree that's recognised back home and across the
            world.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((c) => (
            <div
              key={c.title}
              className="rounded-2xl border border-aiou-sand bg-white p-6 hover:border-aiou-gold/50 hover:shadow-[0_10px_30px_rgba(36,66,101,0.06)] transition-all"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-aiou-steel/8 text-aiou-steel">
                {c.icon}
              </div>
              <h3 className="mt-4 font-serif text-xl text-aiou-ink">{c.title}</h3>
              <p className="mt-2 text-sm text-aiou-slate leading-relaxed">
                {c.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
